// extracted by mini-css-extract-plugin
module.exports = {"bgTransparent":"ForgotPassword_bgTransparent__3auHu","input":"ForgotPassword_input__1SGKP"};